import component from "./AllAroundCollapseContent";

export default component;
